export default __webpack_public_path__ + "static/media/curriculumTick.6524faac.svg";